import { IDirective, IDirectiveFactory, IScope } from "angular";
import { offset } from "@gtmhub/shared/dom";

const insightNames = new Set<string>();

interface ICloseDropdownScope extends IScope {
  insightName: string;
}

export class CloseDropdown implements IDirective {
  public scope = {
    insightName: "@",
  };

  public link(scope: ICloseDropdownScope): void {
    const containerEl = document.querySelector<HTMLElement>(".master-container");
    if (!containerEl) {
      console.warn("Cannot find .master-container");
      return;
    }

    const onScroll = () => {
      for (const insightName of insightNames) {
        const dropdowns = [
          document.querySelector<HTMLElement>(`.info-dropdown-${insightName} .dropdown`),
          document.querySelector<HTMLElement>(`.filters-dropdown-${insightName} .dropdown`),
          document.querySelector<HTMLElement>(`.assignee-dropdown-${insightName} .more-assignees`),
        ];

        const openedDropdowns = dropdowns.filter((dropdown) => dropdown && dropdown.classList.contains("open"));
        for (const openedDropdown of openedDropdowns) {
          const topOfElement = offset(openedDropdown).top;
          const bottomOfElement = topOfElement + openedDropdown.offsetHeight;
          const topOfScreen = containerEl.scrollTop;
          const bottomOfScreen = topOfScreen + containerEl.clientHeight;

          if (bottomOfScreen < topOfElement || topOfScreen > bottomOfElement) {
            openedDropdown.classList.remove("open");
          }
        }
      }
    };

    insightNames.add(scope.insightName);

    // register only one event listener
    if (insightNames.size === 1) {
      containerEl.addEventListener("scroll", onScroll);
    }

    scope.$on("$destroy", () => {
      insightNames.delete(scope.insightName);

      // unregister the listener if it was the last one
      if (insightNames.size === 0) {
        containerEl.removeEventListener("scroll", onScroll);
      }
    });
  }

  public static factory(): IDirectiveFactory {
    const directive = () => new CloseDropdown();
    directive.$inject = [];
    return directive;
  }
}
